import React, { useEffect, ReactElement } from "react";

import { onSnapshotPollDetails } from "../../apis/firebase";

import { pollRedux } from "../../redux";

import { useSelector, useDispatch, shallowEqual } from "react-redux";

let snapshotRef = null;

export default (): ReactElement => {
  const dispatcher = useDispatch();

  const { session } = useSelector(({ session }) => ({ session }), shallowEqual);

  useEffect(() => {
    if (!session || !session.polls) return;

    const activePoll = session.polls.find((d) => d.isActive);

    if (!activePoll) {
      dispatcher(pollRedux.actions.updatePollsInfo({ docId: null }));
      return;
    }

    snapshotRef = onSnapshotPollDetails(activePoll.pollId, (data) => {
      dispatcher(pollRedux.actions.updatePollsInfo({ ...data }));
    });

    return () => {
      snapshotRef();
    };
  }, [session]);

  return <></>;
};
